import { connect } from 'react-redux'

import WishlistToggle from './WishlistToggle'

export default connect(null, null)(WishlistToggle)
